export default "__VITE_ASSET__CY2GNss7__"